import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { AuditGrid } from './-components/AuditGrid';

export const auditSearchSchema = z.object({
  page: z.number().catch(0),
  pageSize: z.number().catch(25),
  /** Free-text query (matches contact ref, field name, or value substring). */
  q: z.string().optional().catch(undefined),
  /** Action chip filter — one of the well-known actions, or undefined for "All". */
  action: z
    .enum(['create', 'update', 'delete', 'consent', 'merge', 'sync', 'import', 'export'])
    .optional()
    .catch(undefined),
  /** Actor id filter, or undefined for "All actors". */
  actor: z.string().optional().catch(undefined),
  /** Selected event id (drives the right-hand detail panel). */
  selected: z.string().optional().catch(undefined),
});

export type AuditSearch = z.infer<typeof auditSearchSchema>;

function AuditLogsRoute() {
  useSetBreadcrumbs([{ label: 'Audit logs' }]);
  return <AuditGrid />;
}

export const Route = createFileRoute('/audit-logs/')({
  validateSearch: auditSearchSchema,
  component: AuditLogsRoute,
  errorComponent: ErrorComponent,
  pendingComponent: () => <LoadingSpinner message="Loading audit logs..." />,
});
